import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DietaryAttributeChips from '../../RecipeV2/components/DietaryAttributeChips';
import { DietaryAttribute } from '../types';

interface RecipeBankDietaryTabProps {
  attributes: DietaryAttribute[];
}

/** Read-only dietary attributes, kept distinct from allergens - never inferred from allergen data. */
const RecipeBankDietaryTab = ({ attributes }: RecipeBankDietaryTabProps) => {
  const { t } = useTranslation('recipeV2');

  if (!attributes.length) {
    return <Typography color="text.secondary">{t('dietary.noAttributes', 'No dietary attributes recorded for this recipe.')}</Typography>;
  }

  return <DietaryAttributeChips attributes={attributes}
    showName />;
};

export default RecipeBankDietaryTab;
